import { assistedAffiliationClient } from "./assistedAffiliationClient";
import { getAssistedAffiliationHost } from "./getAssistedAffiliationHost";
import {
  ApiEnvelope,
  AssistedAffiliationListParams,
  AssistedAffiliationListResponse,
} from "./types";

const assistedAffiliationListEndpoint = "/v1/assisted-affiliation/all";

/**
 * Consulta paginada de solicitudes. Apunta al mock o al servicio definitivo sin cambiar este archivo.
 * @param params - `pageNumber` empieza en 0; `pageSize` es su tamaño.
 * @returns Los items y totales ya desenvueltos; relanza el error para que la pantalla lo traduzca.
 */
export const getAssistedAffiliationListService = async ({
  pageNumber,
  pageSize,
}: AssistedAffiliationListParams): Promise<AssistedAffiliationListResponse> => {
  const host = await getAssistedAffiliationHost();

  // El endpoint es POST porque el body lleva la paginación y, más adelante, los filtros.
  const response = await assistedAffiliationClient.post<
    ApiEnvelope<AssistedAffiliationListResponse>
  >(`${host}${assistedAffiliationListEndpoint}`, { pageNumber, pageSize });

  // El envoltorio se abre aquí para que la pantalla solo vea el listado: si otra API lo adopta o lo
  // deja, el cambio no sale de esta capa.
  return response.data.data;
};
